import React, { memo } from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconX from "../../assets/svg/x.svg";

export interface ICloseButtonProps {
    onClose: () => void;
    className: string;
    iconClassName: string;
}

export const CloseButton = memo(
    ({ onClose, className, iconClassName }: ICloseButtonProps) => (
        <button
            aria-label={t`Close Menu`}
            onClick={onClose}
            className={className}
        >
            <SVG className={iconClassName} src={iconX} aria-hidden="true" />
        </button>
    ),
);
